function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext, useEffect, useRef } from 'react';
import { makeStyles, SwipeableDrawer } from '@material-ui/core';
import shadows from "../../foundations/shadows.module.scss";
import { ChevronLeft } from "../../icons";
import { useStateInRef } from "../../utils/useStateInRef";
import { CloseButton } from "../CloseButton/CloseButton";
import { IconButton } from "../IconButton";
import { useOverlayContext } from "../OverlayContext";
import styles from "./BottomSheet.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IsIBottomSheetContext = /*#__PURE__*/React.createContext(false);
export const useIsInBottomSheet = () => useContext(IsIBottomSheetContext);
export const useBottomSheetStyles = makeStyles({
  paper: _ref => {
    let {
      paddingBottom,
      minHeight
    } = _ref;
    return _objectSpread(_objectSpread({
      borderRadius: '16px 16px 0 0',
      boxShadow: shadows.sh60,
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'calc(100% - 48px)',
      height: 'auto'
    }, minHeight != null && {
      minHeight: "".concat(minHeight, "px")
    }), {}, {
      paddingBottom
    });
  },
  backdrop: {
    backgroundColor: "rgba(0,0,0,0.2)"
  }
});
export function BottomSheet(props) {
  const {
    open,
    onClose,
    onOpen = () => {},
    children,
    showBackButton,
    onBack,
    onExited,
    paddingBottom = 16,
    minHeight,
    testId
  } = props;
  const getProps = useStateInRef(props);
  const {
    isTestMode
  } = useOverlayContext();
  const contentRef = useRef(null);
  const classes = useBottomSheetStyles({
    paddingBottom,
    minHeight
  });
  useEffect(() => {
    const disableSwipeIfInContent = e => {
      if (getProps().open && contentRef.current && e.target && contentRef.current.contains(e.target)) {
        // This tells MUI SwipeableDrawer to not handle the swipe.
        e['muiHandled'] = true;
      }
    };
    document.addEventListener('touchstart', disableSwipeIfInContent, true);
    return () => {
      document.removeEventListener('touchstart', disableSwipeIfInContent);
    };
  }, []);
  return /*#__PURE__*/_jsxs(SwipeableDrawer, {
    disableDiscovery: true,
    disableSwipeToOpen: true,
    classes: {
      paper: classes.paper
    },
    anchor: "bottom",
    open: open,
    onClose: onClose,
    onOpen: onOpen,
    transitionDuration: isTestMode ? 0 : undefined,
    SlideProps: {
      onExited
    },
    ModalProps: {
      BackdropProps: {
        classes: {
          root: classes.backdrop
        }
      }
    },
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.top,
      children: [showBackButton && /*#__PURE__*/_jsx("div", {
        className: styles.backButton,
        children: /*#__PURE__*/_jsx(IconButton, {
          noPadding: true,
          onClick: onBack,
          size: "small",
          "data-testid": "bottom-sheet-back-button",
          children: /*#__PURE__*/_jsx(ChevronLeft, {})
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.swipeIndicator
      }), /*#__PURE__*/_jsx(CloseButton, {
        noPadding: true,
        className: styles.closeButton,
        size: "small",
        onClick: onClose,
        testId: "bottom-sheet-close-button"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.content,
      ref: contentRef,
      "data-testid": testId,
      children: /*#__PURE__*/_jsx(IsIBottomSheetContext.Provider, {
        value: true,
        children: children
      })
    })]
  });
}